import { http } from '../http';

export interface UltimaExecucaoCron {
  status: string;
  origem: string;
  fase: string;
  iniciadoEm: string;
  atualizadoEm: string;
  finalizadoEm: string | null;
  erro: string | null;
}

export interface CronCatalogoItem {
  id: string;
  nome: string;
  modulo: string;
  expressao: string | null;
  agenda: string;
  descricao: string;
  emFalha: string;
  ativo: boolean;
  observacao?: string;
  proximaExecucao: string | null;
  ultimaExecucao: UltimaExecucaoCron | null;
}

/** Catálogo dos crons do sistema (TI/ADMIN, at-34) — alimenta a tela /ti/crons. */
export const fetchCronCatalogo = async (): Promise<CronCatalogoItem[]> => {
  const { data } = await http.get('/cron-catalogo');
  return data;
};
